const data = [
  { id: 11134, attr: 'earth', race: 'elf' },
  { id: 11130, attr: 'earth', race: 'god' },
  { id: 11129, attr: 'light', race: 'dragon' },
  { id: 11044, attr: 'dark', race: 'human' },
  { id: 11043, attr: 'light', race: 'human' },
  { id: 11040, attr: 'earth', race: 'human' },
  { id: 11033, attr: 'fire', race: 'human' },
  { id: 11028, attr: 'fire', race: 'human' },
  { id: 10923, attr: 'earth', race: 'god' },
  { id: 10922, attr: 'light', race: 'demon' },
  { id: 10921, attr: 'fire', race: 'demon', branch: 2 },
  { id: 10920, attr: 'water', race: 'dragon' },
  { id: 10919, attr: 'earth', race: 'demon', branch: 4 },
  { id: 10916, attr: 'dark', race: 'human' },
  { id: 10913, attr: 'water', race: 'human' },
  { id: 10905, attr: 'earth', race: 'human' },
  { id: 10897, attr: 'earth', race: 'human', branch: 123 },
  { id: 10895, attr: 'water', race: 'human' },
  { id: 10874, attr: 'water', race: 'god' },
  { id: 10872, attr: 'light', race: 'elf' },
  { id: 10868, attr: 'earth', race: 'beast' },
  { id: 10857, attr: 'dark', race: 'elf' },
  { id: 10850, attr: 'dark', race: 'god', branch: 2 },
  { id: 10842, attr: 'light', race: 'beast' },
  { id: 10841, attr: 'water', race: 'dragon', branch: 2 },
  { id: 10828, attr: 'water', race: 'machina', branch: 2 },
  { id: 10817, attr: 'dark', race: 'demon' },
  { id: 10804, attr: 'light', race: 'human' },
  { id: 10791, attr: 'dark', race: 'machina' },
  { id: 10784, attr: 'light', race: 'human' },
  { id: 10778, attr: 'light', race: 'human' },
  { id: 10760, attr: 'water', race: 'demon' },
  { id: 10757, attr: 'light', race: 'elf', branch: 2 },
  { id: 10746, attr: 'fire', race: 'human' },
  { id: 10742, attr: 'water', race: 'elf' },
  { id: 10724, attr: 'earth', race: 'human' },
  { id: 10719, attr: 'dark', race: 'dragon' },
  { id: 10714, attr: 'light', race: 'dragon' },
  { id: 10708, attr: 'dark', race: 'elf' },
  { id: 10707, attr: 'dark', race: 'god' },
  { id: 10700, attr: 'light', race: 'human' },
  { id: 10696, attr: 'earth', race: 'human', branch: 3 },
  { id: 10693, attr: 'light', race: 'human' },
  { id: 10692, attr: 'earth', race: 'human' },
  { id: 10686, attr: 'earth', race: 'machina' },
  { id: 10676, attr: 'light', race: 'beast' },
  { id: 10668, attr: 'water', race: 'elf' },
  { id: 10659, attr: 'fire', race: 'machina' },
  { id: 10653, attr: 'dark', race: 'human' },
  { id: 10652, attr: 'light', race: 'human' },
  { id: 10646, attr: 'water', race: 'human' },
  { id: 10645, attr: 'water', race: 'human' },
  { id: 10639, attr: 'dark', race: 'human' },
  { id: 10637, attr: 'earth', race: 'human' },
  { id: 10636, attr: 'fire', race: 'human' },
  { id: 10628, attr: 'dark', race: 'demon' },
  { id: 10619, attr: 'light', race: 'human' },
  { id: 10617, attr: 'earth', race: 'beast' },
  { id: 10610, attr: 'fire', race: 'god' },
  { id: 10598, attr: 'light', race: 'demon' },
  { id: 10580, attr: 'light', race: 'human' },
  // { id: 10577, attr: 'water', race: 'human' },
  { id: 10566, attr: 'dark', race: 'human', branch: 3 },
  { id: 10565, attr: 'light', race: 'dragon' },
  { id: 10563, attr: 'fire', race: 'god' },
  { id: 10542, attr: 'fire', race: 'machina', branch: 2 },
  { id: 10534, attr: 'light', race: 'machina' },
  { id: 10495, attr: 'dark', race: 'human' },
  { id: 10457, attr: 'light', race: 'human' },
  { id: 10450, attr: 'fire', race: 'demon', branch: 13 },
  { id: 10428, attr: 'dark', race: 'human' },
  { id: 10410, attr: 'light', race: 'machina' },
  { id: 10388, attr: 'dark', race: 'human' },
  { id: 10373, attr: 'earth', race: 'machina' },
  { id: 10370, attr: 'dark', race: 'god' },
  { id: 10366, attr: 'water', race: 'human' },
  { id: 10345, attr: 'light', race: 'human' },
  { id: 10336, attr: 'fire', race: 'human' },
  { id: 10329, attr: 'dark', race: 'human', branch: 3 },
  { id: 10172, attr: 'water', race: 'human', branch: 3 },
  { id: 10164, attr: 'fire', race: 'elf' },
  { id: 3010, attr: 'water', race: 'machina' },
  { id: 3007, attr: 'water', race: 'god' },
  { id: 2952, attr: 'earth', race: 'machina' },
  { id: 2924, attr: 'fire', race: 'demon' },
  { id: 2914, attr: 'water', race: 'god' },
  { id: 2909, attr: 'light', race: 'god' },
  { id: 2895, attr: 'light', race: 'demon' },
  { id: 2894, attr: 'water', race: 'demon' },
  { id: 2828, attr: 'fire', race: 'elf', branch: 2 },
  { id: 2791, attr: 'water', race: 'human' },
  { id: 2752, attr: 'dark', race: 'demon', branch: 3 },
  { id: 2726, attr: 'light', race: 'human' },
  { id: 2634, attr: 'fire', race: 'machina' },
  { id: 2598, attr: 'earth', race: 'god', branch: 2 },
  { id: 2487, attr: 'earth', race: 'god' },
  { id: 2186, attr: 'water', race: 'machina' },
];

export default data;
